export const conditionRoutes = {
	conditions: (query: string) => `/product-conditions/${query ? `?${query}` : ''}`,
	condition: (id: string) => `/product-conditions/${id}/`,
	conditionsDelete: '/product-conditions/bulk_delete/'
} as const
